export const environment = {
  API_URL: 'https://test.api.homebase.vandersangen.dev'
};
